// Runtime historical basis seed for Grain Advisor.
// Sources are transcribed from Kevin-uploaded Howlett basis sheets.
// Raw observed basis only: no freight normalization and no buyer/location pooling.

import { HOWLETT_GENEVA_HISTORY } from "./basisHistorySeedGeneva";
import { HOWLETT_2025_12_11 } from "./basisHistorySeed2025";
import { HOWLETT_2026_07_10 } from "./basisHistorySeed2026";

export const HISTORICAL_BASIS_ROWS = [
  ...HOWLETT_GENEVA_HISTORY,
  ...HOWLETT_2025_12_11,
  ...HOWLETT_2026_07_10,
];
